export default {
    loadingFiles(state) {
        state.loading = true;
    },
    successFiles(state, files) {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.data = files;
    },
    errorFiles(state, error) {
        state.loading = false;
        state.success = false;
        state.error = error;
        state.data = [];
    },
    resetSuccessFiles(state) {
        state.success = false;
    },
};
